var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconUtilityNonMains64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 32.5029L13 32.5029",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2763 18.1025H48.846C50.0381 18.1025 51.0045 18.9995 51.0045 20.106V44.8991C51.0045 46.0056 50.0381 46.9025 48.846 46.9025H34.2763C27.1237 46.9025 21.3254 41.5206 21.3254 34.8817V30.1234C21.3254 23.4845 27.1237 18.1025 34.2763 18.1025Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5928 27.7214L41.1858 32.1591L36.5928 36.5968L31.9998 32.1591L36.5928 27.7214Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0046 26.1025H56.3666C57.0478 26.1025 57.6 26.8189 57.6 27.7025C57.6 28.5862 57.0478 29.3025 56.3666 29.3025H51.0046V26.1025Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0046 35.7021H56.3666C57.0478 35.7021 57.6 36.4185 57.6 37.3021C57.6 38.1858 57.0478 38.9021 56.3666 38.9021H51.0046V35.7021Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9815 26.1025H12.9951V38.9025H21.9815C21.5009 37.6453 21.2393 36.2919 21.2393 34.8817V30.1234C21.2393 28.7132 21.5009 27.3598 21.9815 26.1025Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9951 26.1025V25.4525H12.3451V26.1025H12.9951ZM21.9815 26.1025L22.5887 26.3346L22.9259 25.4525H21.9815V26.1025ZM12.9951 38.9025H12.3451V39.5525H12.9951V38.9025ZM21.9815 38.9025V39.5525H22.9259L22.5887 38.6704L21.9815 38.9025ZM12.9951 26.7525H21.9815V25.4525H12.9951V26.7525ZM13.6451 38.9025V26.1025H12.3451V38.9025H13.6451ZM21.9815 38.2525H12.9951V39.5525H21.9815V38.2525ZM22.5887 38.6704C22.1357 37.4856 21.8893 36.2107 21.8893 34.8817H20.5893C20.5893 36.373 20.8661 37.805 21.3744 39.1346L22.5887 38.6704ZM21.8893 34.8817V30.1234H20.5893V34.8817H21.8893ZM21.8893 30.1234C21.8893 28.7944 22.1357 27.5195 22.5887 26.3346L21.3744 25.8704C20.8661 27.2 20.5893 28.6321 20.5893 30.1234H21.8893Z",
    fill: "#1E1E1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconUtilityNonMains64);
export default __webpack_public_path__ + "static/media/pictogramBeaconUtilityNonMains64.e483e45710770f8de0715e006cb16106.svg";
export { ForwardRef as ReactComponent };